import AppLayout from "../layout/Layout";
import StatsLayout from "../layout/dashboardLayout/StatsLayout";
import LazyComponent from "./LazyComponent";
import PrivateRoute from "./protected/PrivateRoute";
import PublicRoute from "./public/PublicRoute";

export const SiteMap = {
  home: {
    title: "home",
    path: "/",
    element: (
      <AppLayout>
        <LazyComponent path="home/Home" />
      </AppLayout>
    ),
    description: "home-Page",
  },
  about: {
    title: "about",
    path: "/about",
    element: (
      <AppLayout>
        <LazyComponent path="about/AboutUs" />
      </AppLayout>
    ),
    description: "about-Page",
  },
  services: {
    title: "service",
    path: "/service",
    element: (
      <AppLayout>
        <LazyComponent path="service/Service" />
      </AppLayout>
    ),
    description: "services-Page",
  },
  PrivacyPolicy: {
    title: "privacyPolicy",
    path: "/privacy-policy",
    element: (
      <AppLayout>
        <LazyComponent path="privacy/PrivacyPolicy" />
      </AppLayout>
    ),
    description: "privacyPolicy-Page",
  },
  termsandconditions: {
    title: "termsandconditions",
    path: "/terms-and-conditions",
    element: (
      <AppLayout>
        <LazyComponent path="privacy/TermsAndConditions" />
      </AppLayout>
    ),
    description: "privacyPolicy-Page",
  },
  aboutUSTheme: {
    title: "about",
    path: "/about-us",
    element: (
      <AppLayout>
        <LazyComponent path="privacy/AboutUsTheme" />
      </AppLayout>
    ),
    description: "aboutus-Page",
  },
  careers: {
    title: "career",
    path: "/careers",
    element: (
      <AppLayout>
        <LazyComponent path="privacy/Careers" />
      </AppLayout>
    ),
    description: "careers-Page",
  },
  blogs: {
    title: "blogs",
    path: "/blog",
    element: (
      <AppLayout>
        <LazyComponent path="privacy/Blogs" />
      </AppLayout>
    ),
    description: "blogs-Page",
  },
  marketing: {
    title: "Marketing",
    path: "/marketing",
    element: (
      <AppLayout>
        <LazyComponent path="privacy/Marketing" />
      </AppLayout>
    ),
    description: "marketing-Page",
  },
  research: {
    title: "Research",
    path: "/research",
    element: (
      <AppLayout>
        <LazyComponent path="privacy/Research" />
      </AppLayout>
    ),
    description: "research-Page",
  },
  android: {
    title: "Android",
    path: "/ios-&-android",
    element: (
      <AppLayout>
        <LazyComponent path="privacy/Android" />
      </AppLayout>
    ),
    description: "android-Page",
  },
  pricing: {
    title: "pricing",
    path: "/pricing",
    element: (
      <PrivateRoute>
        <AppLayout>
          <LazyComponent path="pricing/Price" />
        </AppLayout>
      </PrivateRoute>
    ),
    description: "pricing-Page",
  },

  pricePacakge: {
    title: "pricePackage",
    path: "/pricePackage",
    element: (
      <PrivateRoute>
        <AppLayout>
          <LazyComponent path="pricing/PricePacakge" />
        </AppLayout>
      </PrivateRoute>
    ),
    description: "pricePacakge-Page",
  },
  paymentSucess: {
    title: "paymentSuccess",
    path: "/paymentSuccess",
    element: (
      <PrivateRoute>
        <AppLayout>
          <LazyComponent path="pricing/PaymentSuccess" />
        </AppLayout>
      </PrivateRoute>
    ),
    description: "paymentSucess-Page",
  },
  contact: {
    title: "contact",
    path: "/contact",
    element: (
      <AppLayout>
        <LazyComponent path="contact/Contact" />
      </AppLayout>
    ),
    description: "contact-Page",
  },
  register: {
    title: "register",
    path: "/signup",
    element: (
      <PublicRoute>
        <LazyComponent path="register/Register" />,
      </PublicRoute>
    ),
    description: "register-Page",
  },

  secondregister: {
    title: "seondregister",
    path: "/patientdetail",
    element: (
      <PrivateRoute>
        <LazyComponent path="register/SecondRegister" />
      </PrivateRoute>
    ),
    description: "second_register-Page",
  },

  login: {
    title: "login",
    path: "/login",
    element: (
      <PublicRoute>
        <LazyComponent path="login/Login" />,
      </PublicRoute>
    ),
    description: "login-Page",
  },

  profile: {
    title: "profile",
    path: "/profile",
    element: (
      // <PrivateRoute>
      <LazyComponent path="profile/Profile" />
    ),
    // </PrivateRoute>,
    description: "profile-Page",
  },

  forgetPassword: {
    title: "forgotPassword",
    path: "/forgot",
    element: (
      <PublicRoute>
        <LazyComponent path="forgot/Forgot" />
      </PublicRoute>
    ),
    description: "forgot-Page",
  },

  resetPassword: {
    title: "resetPassword",
    path: "/reset",
    element: <LazyComponent path="reset/Reset" />,
    description: "reset-Page",
  },

  OTP: {
    title: "OTP",
    path: "/otp",
    element: <LazyComponent path="otp/OTP" />,
    description: "OTP-Page",
  },

  dashboard: {
    title: "dashboard",
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <StatsLayout>
          <LazyComponent path="dashboard/Dashboard" />
        </StatsLayout>
      </PrivateRoute>
    ),
    description: "dashboard-Page",
  },
  visualDashboard: {
    title: "visualdashboard",
    path: "/visual",
    element: (
      <PrivateRoute>
        <StatsLayout>
          <LazyComponent path="dashboard/VisualDashboard" />
        </StatsLayout>
      </PrivateRoute>
    ),
    description: "dashboard-Page",
  },

  visualDashboardHealthTable: {
    title: "HealthHistory",
    path: "/healthHistory",
    element: (
      <PrivateRoute>
        <StatsLayout>
          <LazyComponent path="dashboard/rightSideSection/HealthHistory" />
        </StatsLayout>
      </PrivateRoute>
    ),
    description: "dashboard-Page",
  },

  symptomDashboard: {
    title: "symptomdashboard",
    path: "/symptom",
    element: (
      <PrivateRoute>
        <StatsLayout>
          <LazyComponent path="dashboard/VisualSymptom" />
        </StatsLayout>
      </PrivateRoute>
    ),
    description: "dashboard-Page",
  },
  visualNHSI: {
    title: "visualnhsi",
    path: "/visual-nhsi",
    element: (
      <PrivateRoute>
        <StatsLayout>
          <LazyComponent path="dashboard/nhsi/VisualNHSI" />
        </StatsLayout>
      </PrivateRoute>
    ),
    description: "dashboard-Page",
  },
};
